export enum AuthCookiesKey {
  AUTH_SESSION_ID = '_app_billing_session_id'
}
